import { State } from 'store'

export const getActiveAccount = (state: State) => state.preferences.activeAccount
